import { ERROR_MESSAGES } from 'Config/Messages/ErrorMessages';

interface IErrorObject {
  problem: string,
  data: string | {
    internalMessage: string,
    message: string,
    message_code: string,
    errors?: [],
  },
}

export const defaultErrorMessages = (errorObject: IErrorObject): string|boolean => {
  let message;

  switch (errorObject.problem) {
    case 'NETWORK_ERROR' :
      message = 'Netzwerkfehler: Bitte versuchen Sie es später nochmal.';
      break;
    case 'SERVER_ERROR' :
    case 'CLIENT_ERROR' :
      if (errorObject.data === 'Unauthorized') {
        return message || false;
      }
      if (errorObject.data && typeof errorObject.data !== 'string' && !!errorObject.data.errors) {
        // @ts-ignore
        if(errorObject.data.errors.length > 0 && errorObject.data.errors[0].hasOwnProperty('errorMessage')) {
          // @ts-ignore
          message = errorObject.data.errors[0].errorMessage;
        }
      }
      break;
    default :
      break;
  }

  if (errorObject?.data && !message) {
    // @ts-ignore
    const { errorMessage, message_code } = errorObject.data;
    // @ts-ignore
    let { message: error_message } = errorObject.data;
    if(error_message === 'Route not found!') {
      // @ts-ignore
      error_message = `${error_message} (${errorObject.config.method.toUpperCase()}: ${errorObject.data.route})`;
    }
    message = errorMessage || error_message || message_code;
  }

  let responseError = ERROR_MESSAGES[message] || message || 'Serverfehler: Netzwerkfehler: Bitte versuchen Sie es später nochmal.';

  if (!!responseError && typeof responseError === 'function') {
    responseError = responseError(errorObject);
  }

  if (!responseError) {
    // @ts-ignore
    responseError = errorObject.data?.message_code;
  }

  return responseError;

};
